import { appUrl } from "../../../constants/url-constants";

const generateCityObj = (item, isBuyCarCityList) => {
    return {
        label: `${isBuyCarCityList ? "Used Cars in " : "Sell Car in "}${item.city_name}`,
        isHyperLink: true,
        url: isBuyCarCityList ? item.buy_used_car_url : `${appUrl()}/sell-used-car-${item.slug}/`
    };
};

export const getDlsCompatibleCityList = (popularCityDetails) => {
    const {
        "buy-used-car-cities": buyCarCityList = [],
        "sell-used-car-cities": sellCarCityList = []
    } = popularCityDetails || {};

    return {
        buyCarCityList: buyCarCityList.map((item) => generateCityObj(item, true)),
        sellCarCityList: sellCarCityList.map((item) => generateCityObj(item, false))
    };
};
